import { render, staticRenderFns } from "./PrintText.vue?vue&type=template&id=e8831a58&scoped=true"
import script from "./PrintText.vue?vue&type=script&lang=js"
export * from "./PrintText.vue?vue&type=script&lang=js"
import style0 from "./PrintText.vue?vue&type=style&index=0&id=e8831a58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8831a58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8831a58')) {
      api.createRecord('e8831a58', component.options)
    } else {
      api.reload('e8831a58', component.options)
    }
    module.hot.accept("./PrintText.vue?vue&type=template&id=e8831a58&scoped=true", function () {
      api.rerender('e8831a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/PrintText.vue"
export default component.exports